import * as React from 'react';
import { Typography, TextField, Button, InputAdornment, Grid, TablePagination, Hidden } from '@material-ui/core';
import { ProductsSearchBoxProps } from '../connected/ProductsSearchBox';
import SearchIcon from '@material-ui/icons/Search'
import ProductsListSearch from './ProductList/ProductsListSearch';
import OrderSheetPopper from './OrderSheetPopper';
import SearchFilters from './SearchFilters';
import { InsertDriveFile } from '@material-ui/icons'
import { SearchFilter, CategoryFilter } from '../../models/SearchFilter';
import { withRouter } from 'react-router';
import qmoLogo from '../../scss/img/qmo_logo.png';
import { roundedCorners } from '../../QmoTheme';
import { OrderSheetData, OrderSheetItemData } from '../../api/models/OrderSheetData';


const pageSizes = [10, 25, 50]

type State = {
    value: string,
    anhorElement?: HTMLElement,
    index?: any,
    quantities: { [prodId: string]: number },
    rowsPerPage: number,
    currentPage: number,
    orderSheetExpanded: boolean,
    highlights: { [id: string]: string[] },
}

class SearchBox extends React.Component<ProductsSearchBoxProps, State> {
    constructor(props: ProductsSearchBoxProps) {
        super(props);

        this.state = {
            value: '',
            quantities: {},
            rowsPerPage: pageSizes[0],
            currentPage: 0,
            orderSheetExpanded: this.props.currentOrderSheet ? this.props.currentOrderSheet.items.length > 0 : false,
            highlights: {},
        }

        this.typingTimer = null
    }

    typingTimer: NodeJS.Timeout | null

    componentDidUpdate(prevProps: ProductsSearchBoxProps) {
        if (JSON.stringify(prevProps.appliedCategoryFilters) !== JSON.stringify(this.props.appliedCategoryFilters) ||
            JSON.stringify(prevProps.appliedPropertyFilters) !== JSON.stringify(this.props.appliedPropertyFilters)) {
            this.setState({ currentPage: 0 }, this.executeSearch)
        }

        //When current order sheet has changed
        if (this.props.taxonomy && this.props.currentOrderSheet && (this.props.appliedCategoryFilters[0] === undefined || (this.props.currentOrderSheet && this.props.appliedCategoryFilters[0].id !== this.props.currentOrderSheet!.filterCategory))) {
            let orderSheetCategoryFilter = this.props.topCategoryFilters.find((cf) => cf.id === (this.props.currentOrderSheet as OrderSheetData).filterCategory)
            this.props.replaceFilter(orderSheetCategoryFilter!, null) // Reset also the properties filters
        }

        // if (this.props.taxonomy && this.props.currentOrderSheet && (this.props.appliedCategoryFilters[0] === undefined || (this.props.currentOrderSheet && this.props.appliedCategoryFilters[0].id !== this.props.currentOrderSheet!.filterCategory))) {
        //     //let orderSheetCategoryFilter = this.props.topCategoryFilters.find((cf) => cf.id === (this.props.currentOrderSheet as OrderSheetFE).filterCategory)
        //     let orderSheetCategoryFilter: CategoryFilter = new CategoryFilter(this.props.currentOrderSheet.filterCategory, this.props.currentOrderSheet.filterCategory, 0, null) //{id: this.props.currentOrderSheet.filterCategory, count: 0, taxonomyReference: null, field:"category", value:this.props.currentOrderSheet.filterCategory, type: }
        //     this.props.replaceFilter(orderSheetCategoryFilter!, null) // Reset also the properties filters
        // }


        if (!prevProps.orderSheetDirty && this.props.orderSheetDirty && !this.props.orderSheetBusy)
            this.props.updateOrderSheet(this.props.currentOrderSheet!)

        if (prevProps.searchBusy && this.props.searchBusy === false) {
            this.updateHighlights()
        }


    }

    componentWillMount() {
        if (this.props.taxonomy === null)
            this.props.loadTaxonomy()

        this.props.getOrderSheets()
    }

    executeSearch = () => {
        console.log('Triggering search')

        function aggregateFilters(filters: SearchFilter[]): { [name: string]: string[] } {
            if (filters.length > 0)
                return filters.map((af) => af.toSolrFilter()).reduce((af1, af2) => {
                    if (af1[Object.keys(af2)[0]] !== undefined) {
                        af1[Object.keys(af2)[0]].push(Array.from(af2[Object.keys(af2)[0]])[0])
                        return af1
                    }
                    else
                        return Object.assign(af1, af2)
                })
            else
                return {}
        }

        let categoryFilters = aggregateFilters(this.props.appliedCategoryFilters)
        let propertyFilters = aggregateFilters(this.props.appliedPropertyFilters)
        let filter: { [name: string]: string[] } = Object.assign(categoryFilters, propertyFilters)
        this.props.searchTaxonomy(this.state.value, this.state.currentPage * this.state.rowsPerPage, this.state.rowsPerPage, filter)
    }

    onProductAdd = (product: OrderSheetItemData) => {
        this.props.addOrderItem(product)
    }

    onProductPropertyChange = (product: OrderSheetItemData) => {
        this.props.updateProductProperty(product)
    }

    // onProductQuantityChange = (product: OrderSheetItemData) => {
    //     let quantities = Object.assign({},this.state.quantities)
    //     quantities[product.catalogueProductId] = product.quantity!
    //     this.setState({ quantities })
    // }

    onProductRemove = (product: OrderSheetItemData) => {
        this.props.removeOrderItem(product)
    }

    loadMore = () => {
        if (this.props.currentProducts.length < this.state.rowsPerPage * (this.state.currentPage + 1))
            this.executeSearch()
    }

    handleChangePage = (event: any, page: number) => {
        this.setState({ currentPage: page }, this.loadMore)
    }

    handleChangeRowsPerPage = (event: any) => {
        let visibleProducts = Math.min((this.state.currentPage) * this.state.rowsPerPage, this.props.currentProducts.length)
        this.setState({ rowsPerPage: event.target.value, currentPage: Math.floor((visibleProducts > 0 ? visibleProducts - 1 : 0) / Number(event.target.value)) }, this.loadMore)
    }

    getCurrentProductsPage = () => {
        return this.props.currentProducts.slice(this.state.currentPage * this.state.rowsPerPage, this.state.currentPage * this.state.rowsPerPage + this.state.rowsPerPage)
    }

    triggerSearch = () => {
        if (this.typingTimer !== null) {
            clearTimeout(this.typingTimer)
        }
        let doneTypingInterval = 350
        this.typingTimer = setTimeout(() => { this.setState({ currentPage: 0 }, this.executeSearch) }, doneTypingInterval)
    }

    updateHighlights = () => {
        let hl = Object.assign({}, this.state.highlights, this.props.highlights)
        this.setState({ highlights: hl })
    }

    render() {
        return (
            <div>

                {this.props.taxonomy &&

                    <div>
                        {!this.state.orderSheetExpanded &&
                            <div>
                                <Hidden xsDown>
                                    <Grid container alignItems="center">
                                        <Grid item xs={12} sm={2} style={{ textAlign: 'center' }}>
                                            <img alt="" style={{ maxHeight: '100px' }} src={qmoLogo} />
                                        </Grid>
                                        <Grid item xs={12} sm={10}>
                                            <div style={{ paddingBottom: '26px' }}>
                                                <Typography color="textPrimary" variant="h1">Edit order sheet</Typography>
                                                {this.props.currentOrderSheet &&
                                                    <Grid alignItems="center" container>
                                                        <Grid item>
                                                            <InsertDriveFile />
                                                        </Grid>
                                                        <Grid item>
                                                            <Typography color="textPrimary" variant="h2">&nbsp;{this.props.currentOrderSheet!.name}</Typography>
                                                        </Grid>
                                                    </Grid>

                                                }
                                            </div>
                                        </Grid>
                                    </Grid>
                                </Hidden>

                                <div>
                                    <TextField placeholder={"Search in " + (this.props.appliedCategoryFilters.length > 0 ? this.props.appliedCategoryFilters[this.props.appliedCategoryFilters.length - 1].taxonomyReference!.name : "products")}
                                        variant="outlined"
                                        style={Object.assign({ width: "100%", backgroundColor: 'white' }, roundedCorners, { borderRadius: '100px' })}
                                        value={this.state.value || ""}
                                        onChange={(e) => {
                                            this.setState({ value: e.target.value, highlights: {} })
                                            this.triggerSearch()
                                        }}
                                        inputRef={(node) => this.state.anhorElement || this.setState({ anhorElement: node })}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <Button variant="contained" color="primary"
                                                        style={{
                                                            width: '56px', height: '56px',
                                                            minWidth: 0,
                                                            borderRadius: '100px',
                                                            boxShadow: 'none',
                                                            marginRight: '-14px',
                                                            color: 'white'
                                                        }}
                                                        onClick={this.triggerSearch}
                                                    >
                                                        <SearchIcon />
                                                    </Button>
                                                </InputAdornment>
                                            ),
                                        }}

                                    />

                                    {this.props.currentOrderSheet &&
                                        <span>
                                            <div style={{ marginTop: '15px' }}></div>

                                            <SearchFilters
                                                isBusy={this.props.searchBusy}
                                                filtersToPick={this.props.currentCategoryFilters}
                                                appliedFilters={this.props.appliedCategoryFilters}
                                                applyFilter={this.props.applyFilter}
                                                removeFilter={this.props.removeFilter}

                                                replaceFilter={this.props.replaceFilter}
                                                appliedPropertyFilters={this.props.appliedPropertyFilters}
                                                currentProductProperties={this.props.currentProductProperties}>
                                            </SearchFilters>

                                            <div style={{ marginTop: '15px' }}></div>

                                            <ProductsListSearch
                                                updateOrderSheetBusy={this.props.updateOrderSheetBusy}
                                                replaceFilter={this.props.replaceFilter}
                                                appliedPropertyFilters={this.props.appliedPropertyFilters}
                                                currentProductProperties={this.props.currentProductProperties}
                                                searchValue={this.state.value}
                                                isBusy={this.props.searchBusy}
                                                onProductAdd={this.onProductAdd}
                                                onProductPropertyChange={this.onProductPropertyChange}
                                                orderProducts={this.props.currentOrderSheet!.items}
                                                products={this.getCurrentProductsPage()}
                                                highlights={this.state.highlights}>
                                            </ProductsListSearch>
                                        </span>
                                    }

                                    <TablePagination
                                        rowsPerPageOptions={pageSizes}
                                        component="div"
                                        count={this.props.totalResults}
                                        rowsPerPage={this.state.rowsPerPage}
                                        page={this.state.currentPage}
                                        backIconButtonProps={{
                                            'aria-label': 'Previous Page',
                                        }}
                                        nextIconButtonProps={{
                                            'aria-label': 'Next Page',
                                        }}
                                        labelRowsPerPage={"Products per page:"}
                                        onChangePage={this.handleChangePage}
                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                    />

                                    {/* This will prevent the fixed OrderSheetPopper from overlapping the content */}
                                    <div style={{ height: '12vh' }}></div>
                                </div>
                            </div>
                        }

                        {this.props.currentOrderSheet &&
                            <OrderSheetPopper
                                updateOrderSheetBusy={this.props.updateOrderSheetBusy}
                                orderSheet={this.props.currentOrderSheet}
                                createOrderAndQuoteIt={this.props.createOrderAndQuoteIt}
                                updateOrderSheet={this.props.updateOrderSheet}
                                onOrderSheetRename={this.props.renameOrderSheet}
                                onOrderItemQuantityChange={this.props.changeOrderItemQuantity}
                                onOrderItemRemove={this.props.removeOrderItem}
                                expandByDefault={this.state.orderSheetExpanded}
                                onExpand={(expanded: boolean) => this.setState({ orderSheetExpanded: expanded })}
                            ></OrderSheetPopper>
                        }

                    </div>
                }
            </div>
        );
    }
}

export default withRouter(SearchBox);